export default class SpecialPostPopupController {
	constructor() {
		this.initialized = false;
		this.modalShown = false;
	}

	init() {
		if (this.initialized) {
			return;
		}

		const overlay = document.getElementById('overldplay');
		const closeButton = document.getElementById('close-even-ldp');

		if (!overlay || !closeButton) {
			return;
		}

		this.initialized = true;

		document.addEventListener(
			'scroll',
			() => {
				const scrollPosition = window.scrollY || document.documentElement.scrollTop;

				if (scrollPosition > 100 && !this.modalShown) {
					this.modalShown = true;
					overlay.style.display = 'flex';
					overlay.classList.add('show-even-ldp');
				}
			},
			{ passive: true }
		);

		closeButton.addEventListener('click', () => this.hideOverlay(overlay));
		overlay.addEventListener('click', (event) => {
			if (event.target === overlay) {
				this.hideOverlay(overlay);
			}
		});
	}

	hideOverlay(overlay) {
		overlay.classList.remove('show-even-ldp');
		overlay.addEventListener(
			'transitionend',
			() => {
				if (!overlay.classList.contains('show-even-ldp')) {
					overlay.style.display = 'none';
				}
			},
			{ once: true }
		);
	}
}
